'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Linking = exports.Linking = {
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  getInitialURL: function getInitialURL() {
    return Promise.reject('Unsupported platform');
  }
};

var BackAndroid = exports.BackAndroid = {
  addEventListener: function addEventListener() {}
};


//////////////////
// WEBPACK FOOTER
// ./~/react-navigation/lib/PlatformHelpers.js
// module id = 61
// module chunks = 0